import React, { PureComponent } from "react";
import { zoomModeInfo, BUTTON_BACKGROUND_COLOR, BUTTON_ACTIVE_COLOR, BUTTON_HOVER_SHADOW_COLOR } from "../../helpers/Const";
import styled from "styled-components/macro";
import { connect } from "react-redux";
import { SettingsPanelContainerColumn, SettingsPanelSpan } from "../common/StyledComponents";
import { withTranslation, WithTranslation } from "react-i18next";
import { Dispatch } from "src/rematch/store";
import { Action } from "@rematch/core";

const ZoomModeSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

interface IZoomModeItemProps {
  selected?: boolean;
}

const ZoomModeItem = styled.label`
  flex: 0 0 76px;
  display: flex;
  align-items: center;
  background: ${(props: IZoomModeItemProps) => (props.selected ? BUTTON_ACTIVE_COLOR : BUTTON_BACKGROUND_COLOR)};
  height: 32px;
  justify-content: center;
  margin: 0 1px;
  border: 0;
  padding: 0;
  color: #fff;
  cursor: pointer;

  &:active {
    background: ${BUTTON_ACTIVE_COLOR};
    box-shadow: inset 0 0 0 3px #00000000;
  }
  &:hover {
    box-shadow: inset 0 0 0 3px ${BUTTON_HOVER_SHADOW_COLOR};
  }
`;

interface IZoomModeSelectorProps extends WithTranslation {
  zoomMode: string;
  setZoomMode: (zoomMode: string) => Action<string,void>;
}

class ZoomModeSelector extends PureComponent<IZoomModeSelectorProps> {
  applyZoomModeChange = (event: React.MouseEvent<HTMLElement,MouseEvent>) => {
    this.props.setZoomMode((event.target as HTMLElement).id);
  };

  getInputElements = () => {
    const { t } = this.props;
    const inputs = [];
    let index = 0;
    for (const zoomLevelType in zoomModeInfo) {
      const selected = this.props.zoomMode === zoomLevelType;
      inputs.push(
        <ZoomModeItem id={zoomLevelType} onClick={this.applyZoomModeChange} selected={selected} htmlFor={zoomLevelType} key={index++}>
          {t(`zoommode.${zoomModeInfo[zoomLevelType].labelText}`)}
        </ZoomModeItem>
      );
    }
    return inputs;
  };

  render = () => {
    const { t } = this.props;
    return (
      <SettingsPanelContainerColumn>
        <SettingsPanelSpan>{t("pageheader.zoommode")}</SettingsPanelSpan>
        <ZoomModeSelectorContainer>{this.getInputElements()}</ZoomModeSelectorContainer>
      </SettingsPanelContainerColumn>
    );
  };
}

const mapDispatch = (dispatch: Dispatch) => ({
  setZoomMode: (zoomMode: string) => dispatch.UI.setZoomMode(zoomMode),
});

export default withTranslation()(connect(null, mapDispatch)(ZoomModeSelector));
